module.exports = __webpack_public_path__ + "img/reloadDodIcon.b5805d21.svg";